import { useState } from 'react';
import { PricingFaq } from './PricingFaq';
import { PricingIntervalToggle } from './PricingIntervalToggle';
import { PricingPlanGroup } from './PricingPlanGroup';
import { SeeFullComparisonButton } from './SeeFullComparisonButton';
import { PRICING_PLANS } from './pricingPlans.config';
import { StripeData } from '@/UI/Subscription/Subscription.page';

type Props = {
  stripeData: StripeData;
  isBillingYearly: boolean;
  onBillingYearlyChange: (isBillingYearly: boolean) => void;
};

export const PricingPlans = ({ stripeData, isBillingYearly, onBillingYearlyChange }: Props) => {
  const soloPlans = PRICING_PLANS.filter((plan) => plan.group === 'solopreneurs');
  const bizPlans = PRICING_PLANS.filter((plan) => plan.group === 'businesses');
  const [openFaq, setOpenFaq] = useState('');

  const handleFaqLink = (faqKey: string) => {
    setOpenFaq(faqKey);
    requestAnimationFrame(() => {
      document
        .getElementById(`faq-${faqKey}`)
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  return (
    <div className="flex flex-col gap-12">
      <div className="flex justify-start">
        <PricingIntervalToggle isBillingYearly={isBillingYearly} onChange={onBillingYearlyChange} />
      </div>
      <PricingPlanGroup
        groupKey="solopreneurs"
        plans={soloPlans}
        isBillingYearly={isBillingYearly}
        stripeData={stripeData}
        onFaqLink={handleFaqLink}
      />
      <PricingPlanGroup
        groupKey="businesses"
        plans={bizPlans}
        isBillingYearly={isBillingYearly}
        stripeData={stripeData}
        onFaqLink={handleFaqLink}
      />
      <SeeFullComparisonButton />
      <PricingFaq openValue={openFaq} onOpenChange={setOpenFaq} />
    </div>
  );
};
